module.exports = __webpack_public_path__ + "media/images/logos/personio-adbcb564dd7854f52e0b67cc55e9dc81.png";